import { fetchWithFullyQualifiedUrl } from "lib/fetch";
import toast from "lib/toast";

export const openBulkExportReport = async (reportJobIds, userRoleSlug) => {
  const response = await fetchWithFullyQualifiedUrl(
    `/v2/report-jobs/bulk-export/?user_role=${userRoleSlug}`,
    {
      headers: {
        Accept: "text/html",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        report_job_ids: reportJobIds,
      }),
    },
  );
  // Response is redirect - open in new tab
  if (response.redirected) {
    window.open(response.url);
  } else {
    toast.error(
      `Bulk export responded with code: ${response.status} (${response.statusText})`,
    );
  }
};
